
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AdContentDetail": [
      "AdAboveChart",
      "AdAppEnding",
      "AdAppOpening",
      "AdBottomFloating",
      "AdCommunityFeedArticle",
      "AdContentDefault",
      "AdForegroundPopup",
      "AdInappNoti"
    ],
    "ArticleCommentContent": [
      "ArticleContentText"
    ],
    "ArticleContent": [
      "ArticleContentAsset",
      "ArticleContentBackTestingProject",
      "ArticleContentImage",
      "ArticleContentOgTag",
      "ArticleContentPortfolio",
      "ArticleContentText"
    ],
    "ArticleContentSubTextComponent": [
      "ArticleContentTextSubTextComponentCrypto",
      "ArticleContentTextSubTextComponentStock",
      "ArticleContentTextSubTextComponentText",
      "ArticleContentTextSubTextComponentUser"
    ],
    "ArticleTag": [
      "ArticlePortfolioTopic",
      "ArticleStockTag"
    ],
    "BackTestingAsset": [
      "BackTestingCrypto",
      "BackTestingStock"
    ],
    "BackTestingCase": [
      "BackTestingCrypto",
      "BackTestingPortfolio",
      "BackTestingStock"
    ],
    "FollowItem": [
      "FollowCompany",
      "FollowCryptoCurrency",
      "FollowFeedTopic",
      "FollowUser"
    ],
    "InvestingDiaryLog": [
      "InvestingDiaryDepositWithdrawalLog",
      "InvestingDiaryExchangeCurrencyLog",
      "InvestingDiaryMemoLog",
      "InvestingDiaryTradeLog"
    ]
  }
};
      export default result;
    